export const CHAT_BRAND = {
  name: 'Chat',
  possessive: "Chat's",
  plural: 'Chats',
} as const;
